import { Injectable } from '@angular/core';
import { UrlBasePathService } from '../../utils/UrlBasePathUtil';
import * as Dexie from 'dexie';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class KeyValueStorageService {

  dbName = 'keyValueStorage';
  dbVersion = 1;
  objectName = 'localStorage';
  idb = null;

  constructor(private urlBasePathService: UrlBasePathService) {
  }

  public setItem(key, value) {
    const self = this;
    return new Promise<any>((resolve, reject) => {
      this.getDatabase().then(function success(db) {
        db.transaction('rw', db[self.objectName], (result) => {
          db[self.objectName].put({key: key, value: value}).then((data) => {
            resolve(result);
          }, (e) => {
            logger.error('Error on IndexedDBService.saveEntry:');
            logger.error(e);
            reject(e);
          });
        }).catch(e => {
          logger.error('Error adding entry to IndexedDB: ' + e.stack || e);
          reject(e);
        });
      });

    });
  }

  public getItem(key) {
    key = this.urlBasePathService.getBasePath() + key;
    const self = this;
    return new Promise<any>((resolve, reject) => {
      this.getDatabase().then(function success(db) {
        db[self.objectName].where('key').equals(key).each(results => {
          resolve(results.value);
        }).catch(function(error) {
          logger.error('Error getting dexie entries: ' + error.message);
          reject(error);
        });
      });
    });
  }

  public removeItem(key) {
    key = this.urlBasePathService.getBasePath() + key;
    const self = this;
    return new Promise<any>((resolve, reject) => {
      this.getDatabase().then(function success(db) {
        db[self.objectName].where('key').equals(key).delete().then(deleteCount => {
          resolve(deleteCount);
        }).catch(function(error) {
          logger.error('Error removing dexie entries: ' + error.message);
          reject(error);
        });
      });
    });
  }

  getDatabase(): Promise<any> {
    const self = this;
    return new Promise<any>(function(resolve, reject) {
      if (self.idb) {
        resolve(self.idb);
      } else {
        const db = new Dexie.default(self.dbName);
        db.version(self.dbVersion).stores({
            localStorage: 'key'
          }
        );
        self.idb = db;
        resolve(self.idb);
      }
    });
  }

}
